export default __webpack_public_path__ + "static/media/008.b82ea77b.jpg";